/**
 * `phaser-navmesh` is a Phaser v3 wrapper around `navmesh` that creates a Phaser 3 Scene plugin.
 * Phaser 3 is expected to be a dependency in your project.
 * @packageDocumentation
 * @module phaser-navmesh
 */
import PhaserNavMeshPlugin from "./phaser-navmesh-plugin";
import PhaserNavMesh from "./phaser-navmesh";
export { PhaserNavMeshPlugin, PhaserNavMesh };
export default PhaserNavMeshPlugin;
